import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { GeneralService } from 'src/app/core/services/general/general.service';
import { Carrera } from '../../models/observacion';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-buscador-posgrados-tematico',
  templateUrl: './buscador-posgrados-tematico.component.html',
  styleUrls: ['./buscador-posgrados-tematico.component.scss']
})
export class BuscadorPosgradosTematicoComponent implements OnInit {
  @Input() data: any = { background_color: "#c1b283" };
  @Input() area: any = {};
  @Input() titulo;
  @Input() translateY = "";
  @Input() padding = "38.6px 35px";
  @Input() paddingMob = "35px";
  language;
  facultadParam;
  nivelPrioridad = ['Doctorado', 'Maestría', 'Especialización', 'Curso de Posgrado', 'Curso Acreditable'];
  titulos = [
    { singular: 'Doctorado', plural: "Doctorados" },
    { singular: 'Maestría', plural: "Maestrías" },
    { singular: 'Especialización', plural: "Especializaciones" },
    { singular: 'Curso de Posgrado', plural: "Cursos de Posgrado" },
    { singular: 'Curso Acreditable', plural: "Cursos Acreditables" },
  ];
  spinner = true;
  filtro = false;
  numberActive: number = 1;
  regiones: string[] = [];
  carreras: any
  niveles: Carrera[] = [];
  areas: Carrera[] = [];
  facultades: Carrera[] = [];
  modalidades: Carrera[] = [];
  resultados: Carrera[] = [];
  buscador: UntypedFormGroup;
  carrerasArray: any
  carrerasAux: any
  constructor(private form: FormBuilder, private services: GeneralService, public route: ActivatedRoute) {
    this.route.params.forEach((params: Params) => {
      this.language = (params['language']) ? params['language'] : 'es';
    });
    this.buscador = this.form.group({
      sede: ['',],
      area: ['',],
      nivel: ['',],
      modalidad: ['',],
      facultad: ['',],
      palabras: ['',],
      venueId: ['',],
    });

    let facultadParam = this.route.snapshot.queryParamMap.get('facultad');
    if(facultadParam){
      //this.facultadParam = Number(facultadParam);
       this.buscador.controls['venueId'].setValue(Number(facultadParam));
    }
  }
  @ViewChild('filtroInput') filtroInput!: ElementRef;

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.filtroInput.nativeElement.focus({ preventScroll: true });
    }, 100);
  }
  ngOnInit(): void {
    this.filtrar();
    this.services.getFacultadByArea(this.area.name).subscribe(data => {
      data.data[0].venue.forEach(facultadad => {
        facultadad.title = this.eliminarPrefijoFacultad(facultadad.title);
        this.facultades.unshift(facultadad)
      })
      
      data.data[0].region.forEach(sede => {
        sede.title = this.eliminarPrefijoFacultad(sede.title);
        this.regiones.unshift(sede)
      })
       let facultadParam = this.route.snapshot.queryParamMap.get('facultad');
       if(facultadParam){
         this.facultadParam = Number(facultadParam);
       }
      
    })
  }

  eliminarPrefijoFacultad(cadena: string): string {
    const prefijo = 'Facultad de';
    if (cadena && cadena.startsWith(prefijo)) {
      return cadena.substring(prefijo.length).trim();
    } else {
      return cadena;
    }
  }

  updateFilter(field: string, value: any) {
    console.log(value)
    this.buscador.get(field).setValue(value);
    this.filtrar();
  }
  private posgradosSub: Subscription;

  filtrar() {
    this.checkDeviceType();
    this.spinner = true;

    const sede = this.buscador.get('sede').value;
    const nivel = this.buscador.get('nivel').value;
    const area = this.area.name;
    const modalidad = this.buscador.get('modalidad').value;
    const palabras = this.buscador.get('palabras').value;
    const venue = this.buscador.get('venueId').value;
    const resultados = document.getElementById("resultados");

    // 🚫 Cancelar la petición anterior si sigue activa
    if (this.posgradosSub) {
      this.posgradosSub.unsubscribe();
    }

    this.posgradosSub = this.services
      .getPosgrados(sede, nivel, area, palabras, null, modalidad, venue)
      .subscribe({
        next: (data) => {
          let aux = [];
          this.resultados = [];
          this.carreras = [];
          this.niveles = data.data[0].careerType;
          this.modalidades = data.data[0].modalidad;
          this.areas = data.data[0].area;

          if (data.data[0].career) {
            this.carrerasAux = data.data[0].career;
            const carrerasOriginales = this.carrerasAux;

            const carrerasAgrupadas: {
              [nivel: string]: { carreras: any[]; color: string };
            } = {};

            carrerasOriginales.forEach(carrera => {
              const nivel = carrera.nivel;
              if (!carrerasAgrupadas[nivel]) {
                carrerasAgrupadas[nivel] = { carreras: [], color: carrera.color };
              }
              carrerasAgrupadas[nivel].carreras.push(carrera);
            });

            this.carreras = carrerasAgrupadas;
            this.carrerasArray = Object.entries(this.carreras).map(([nivel, carreras]) => ({
              nivel,
              carreras
            }));

            this.carrerasArray.sort(
              (a, b) => this.nivelPrioridad.indexOf(a.nivel) - this.nivelPrioridad.indexOf(b.nivel)
            );

            // 🏷️ Asignar títulos plural o singular
            this.nivelPrioridad.forEach(nombreNivel => {
              const nivelItem = this.carrerasArray.find(d => d.nivel == nombreNivel);
              const carreras = nivelItem?.carreras?.carreras;
              if (carreras?.length > 1) {
                const titulo = this.titulos.find(d => d.singular == nombreNivel);
                if (titulo) nivelItem.nivel = titulo.plural;
              }
            });
          }

          // Mostrar u ocultar resultados
          if (sede == '' && nivel == '' && area == '' && modalidad == '' && palabras == '') {
            this.resultados = [];
            this.filtro = false;
            if (resultados) resultados.style.display = 'none';
          } else {
            this.filtro = true;
            if (resultados) resultados.style.display = 'block';
          }

          this.spinner = false;
        },
        error: (err) => {
          console.error('Error en getPosgrados:', err);
          this.spinner = false;
        }
      });
  }

  ngOnDestroy() {
    // 🧹 Limpieza al destruir el componente
    if (this.posgradosSub) {
      this.posgradosSub.unsubscribe();
    }
  }

  cortarTitulo(titulo) {
    if (titulo.length > 50) {
      return titulo.slice(0, 50) + "...";
    } else {
      return titulo;
    }
  }


  filtros(modalidad: string): any[] {
    let listaFiltrada = this.carrerasAux;
    if (modalidad) {
      listaFiltrada = listaFiltrada.filter(r => {
        if (r.modalidad) {
          return this.processText(r.modalidad) === this.processText(modalidad);
        } /* else {
          return true; 
        } */
      });
    }

    listaFiltrada.sort((a, b) => {
      const fechaA = new Date(a.fecha);
      const fechaB = new Date(b.fecha);

      const difA = Math.abs(Math.ceil((fechaA.getTime() - new Date().getTime()) / (1000 * 3600 * 24)));
      const difB = Math.abs(Math.ceil((fechaB.getTime() - new Date().getTime()) / (1000 * 3600 * 24)));

      if (difA < difB) {
        return -1;
      } else if (difA > difB) {
        return 1;
      } else {
        return fechaA.getTime() - fechaB.getTime();
      }
    });
    return listaFiltrada;
  }
  processText(palabra: string): string {
    palabra = palabra.trim();
    palabra = palabra.toLocaleLowerCase();

    return palabra;
  }
  getCarrerasKeys(): string[] {
    return Object.keys(this.carreras);
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.checkDeviceType()
  }
  getMarginTop(height: any) {
    let marginTopResultados = '0px'
    if (this.translateY.includes("%")) {
      let porcentaje = parseFloat(this.translateY) / 100;
      marginTopResultados = (height * porcentaje) + 30 + "px";
    }
    return marginTopResultados;
  }
  heightSearch = 0;
  checkDeviceType() {

    if (this.heightSearch == 0) this.heightSearch = $(".buscador-container").outerHeight();
    $(".resultados").css("margin-top", "-" + this.getMarginTop(this.heightSearch));


    let isDesktop = window.innerWidth >= 768;
    $(".buscador-container").css("background-color", this.data.background_color + "");
    if (isDesktop) {
      $(".buscador-container").css("padding", this.padding);
      $(".buscador-container").css("transform", "translateY(-" + this.translateY + ")");
      $(".resultados").css("margin-bottom", (this.resultados.length == 0) ? 90 : 0 + "px");

    } else {
      $(".buscador-container").css("padding", this.paddingMob);
      $(".buscador-container").css("transform", "translateY(-" + 0 + "px)");
      $(".resultados").css("margin-top", "-" + 0 + "px");
      $(".resultados").css("margin-bottom", (this.resultados.length == 0) ? 120 : 70 + "px");

    }

  }
}
